import { withStyles } from "@material-ui/core";
import React from "react";

const styles = (theme) => ({
  message: {
    color: theme.errorBorderColor,
    fontSize: 10,
  },
  errorHeader: {
    color: theme.errorBorderColor,
    marginTop: 16,
    fontSize: 10,
    textTransform: "uppercase",
    letterSpacing: 1.5,
    fontWeight: 600,
  },
});

const ErrorContainer = ({ label, message, classes }) => {
  return (
    <>
      <div className={classes.errorHeader}>{label}</div>
      <div item xs={12} className={classes.message}>
        {message}
      </div>
    </>
  );
};

export default withStyles(styles)(ErrorContainer);
